export const DEFAULT_TABLE_ROW_HEIGHT_PX = 52;
export const HEADER_ROW_FALLBACK_PX = 48;
export const STACKED_CARD_FALLBACK_PX = 140;
export const PAGINATION_FOOTER_FALLBACK_PX = 56;
/** Slack so zoom / touch-target jumps never clip footer under shell overflow. */
export const PAGINATION_FOOTER_SAFETY_PX = 16;
export const MIN_VIEWPORT_PAGE_SIZE = 5;
export const MAX_VIEWPORT_PAGE_SIZE = 100;
/** Extra px per row when fitting page size (borders, subpixel layout). */
export const VIEWPORT_ROW_HEIGHT_PADDING_PX = 8;
/** Pre-measure estimate multiplier when tbody rows are not laid out yet. */
export const VIEWPORT_ROW_HEIGHT_ESTIMATE_FACTOR = 1.2;

/** Shell page-size helper (optional; catalog uses fixed pageSize + body scroll). */
export const MIN_SHELL_PAGE_SIZE = 5;
export const MAX_SHELL_PAGE_SIZE = 100;
export const SHELL_PAGE_SIZE_PAD_PX = 4;

/** Default client page size for `pagination.mode === 'client'`. */
export const DEFAULT_CLIENT_PAGE_SIZE = 25;

export const DATATABLE_PAGINATED_HEIGHT_CAP =
  'var(--wp-datatable-max-height, 100%)' as const;

/** Auto-enable row virtualization at or above this count (embedded scroll lists). */
export const VIRTUALIZE_ROW_THRESHOLD = 50;
